/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
     this.container = document.getElementById('Search-Drawer');    
     this.container1 = document.getElementById('Search-Drawer1'); 
    
    this.form = this.container.querySelector('form.searchform');
    this.form1 = this.container1.querySelector('form.searchform');
    
    this.button = document.querySelectorAll('.thb-quick-search'); 
    
    
    this.content = this.container.querySelector(".search-bar__inner");
    this.content1 = this.container1.querySelector(".search-bar__inner");
    
    this.input = this.container.querySelector('input[type="search"]');
    this.input1 = this.container1.querySelector('input[type="search"]');
    
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.defaultTab1 = this.container1.querySelector('.side-panel-content--initial');
    
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');
    this.predictiveSearchResults1 = this.container1.querySelector('.side-panel-content--has-tabs');

    console.log(this.predictiveSearchResults1);
    
    this.body = document.querySelector("body");
    this.close = document.querySelector(".search-close__btn");
    this.submit = document.querySelector(".search-submit");

   
    this.setupEventListeners();

   
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.form1.addEventListener('submit', this.onFormSubmit1.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    
    this.input1.addEventListener('input', debounce((event) => {
      this.onChange1(event);
    }, 300).bind(this));
    
    this.body.addEventListener('click', this.onClose.bind(this));
    this.input1.addEventListener('click',this.onDisplay.bind(this));    
    this.submit.addEventListener("click", this.onSubmit.bind(this));    

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function() {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });

  }
  onClose(event) {
    let currentElement = event.srcElement;
    if (currentElement.closest(".header-search")) {
      
    }else {      
    this.content1.classList.remove('is-expanded'); 
    }        
  }
 
  onDisplay() {
    let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    this.content1.classList.add('is-expanded');  
    
  }
  getQuery() {
    return this.input.value.trim();
  }
  getQuery1() {
    return this.input1.value.trim();
  }
  onSubmit() {
    this.form1.submit();
  } 
  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }
  onChange1() {
    console.log("changed");
    const searchTerm = this.getQuery1();
    if (!searchTerm.length) {
      this.predictiveSearchResults1.classList.remove('active');
      return;
    }
    this.predictiveSearchResults1.classList.add('active');
    this.getSearchResults1(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }
  onFormSubmit1(event) {
    if (!this.getQuery1().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }
  onFocus1() {
    const searchTerm = this.getQuery1();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults1(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  getSearchResults1(searchTerm) {
    console.log("get result");
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults1.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults1.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults1(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  renderSearchResults1(resultsMarkup) {
    this.predictiveSearchResults1.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container1.querySelector('#search-results-submit');


    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});